import React from "react";
import { breadcrumbs } from "../../common/breadcrumbs";
import { TopBanner } from "../../common/TopBanner";
import { customer_voice } from "../../common/customer_voice";
import Tab from "semantic-ui-react/dist/commonjs/modules/Tab";
import { Link } from "../../lib/Link";

export const lineup = type => {
  document.title =
    "トランクルームをお探しなら『ハローストレージ』【公式】｜商品ラインナップ";
  return (
    <div className="container">
      {breadcrumbs(type, [{ text: "商品ラインナップ" }])}

      <div className="beginner">
        <div className="toppanel">
          <div>
            <div className="title">商品ラインナップ</div>
            <div className="text">
              <span>トランクルームなど弊社が提供している</span>
              <span>サービスの概要をご説明しています。</span>
              <span>初めての方は是非お読みください。</span>
            </div>
          </div>
        </div>
        <div className="content">
          <div className="collection">
          <Link to="contena/" className="item">
              <div className="image outside" />
              <div className="title">屋外型トランクルーム</div>
              <div className="text">
                海上運送用の丈夫なコンテナを利用した大型収納スペースです。
                コンテナ前まで乗り入れ可能なので、お荷物の出し入れがとてもスムーズにできます。
              </div>
              <ul className="list">
                <li>北海道から九州まで展開する、屋外型トランクルーム</li>
                <li>コンテナ前まで車乗り入れ可能</li>
                <li>全国で約60,000室を展開</li>
              </ul>
            </Link>
            <Link to="trunk/" className="item">
              <div className="image inside" />
              <div className="title">屋内型トランクルーム</div>
              <div className="text">
                24時間利用可能な屋内型の収納スペースです。
                セキュリティ完備なので、女性でも安心。
                首都圏中心に約17,000室と最大級の取り揃え。
              </div>
              <ul className="list">
                <li>都圏最大数の屋内型トランクルーム</li>
                <li>セコムまたはALSOKの2重ロックで24時間使用可能</li>
                <li>首都圏中心に約17,000室</li>
              </ul>
            </Link>
            <Link to="premium/" className="item">
              <div className="image premium" />
              <div className="title">トランクハウス24シリーズ</div>
              <div className="text">
                トランクルーム専用に設計した1軒家型の屋内収納スペースです。
                広すぎない、無駄をなくしたスマート設計のコンパクトタイプを充実させ、環境になじんだシックな外観と、親しみやすいハローキティデザインを採用。
              </div>
              <ul className="list">
                <li>無料駐車場完備</li>
                <li>安心の警備会社セキュリティ完備</li>
                <li>清潔感のある外装・内装で女性の方にお勧め</li>
              </ul>
            </Link>
            <Link to="bike/" className="item">
              <div className="image motorbike" />
              <div className="title">バイク専用トランクルーム</div>
              <div className="text">
                BOX型、屋外型、室内型と複数のタイプをご用意したバイク専用の収納スペースです。
              </div>
              <ul className="list">
                <li>複数のタイプが選べる</li>
                <li>
                  盗難やイタズラから愛車を守りたい/大切なバイクを雨風で汚したくない
                </li>
                <li>首都圏中心に約70現場を展開中</li>
              </ul>
            </Link>
          </div>
          <div className="characteristic">
            <div className="title">ハローストレージの特徴</div>
            <div className="text">
              <p>トランクルームで、暮らしを変えてみませんか？</p>
              <p>
              ハローストレージは、「家庭用」「企業用」のトランクルームとして誕生しました。
              </p>
              <p>
                室内を大小のスペースに区画して、各種サイズの収納空間を、リーズナブルにご提供いたします。
              </p>
               皆様の身近な場所にご提供できるよう、全国展開で、物件数も業界No.1！
              <br />
              ハローストレージは、あなたの「してみたい暮らし」を実現するお手伝いをいたします。
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./pages/new/lineup.jsx